import { useNavigate } from "react-router-dom";
import { addJob } from "../../services/jobService";
import {
    Grid2 as Grid,
    Box,
    TextField,
    Typography,
    Button,
    FormControlLabel,
    Checkbox,
    Autocomplete,
} from "@mui/material";
import * as yup from "yup";
import React, { useState } from "react";
import { useFormik } from "formik";
import { ToastContainer } from "react-toastify";
import bgImage from '../../assets/img/newimgaes/Property Services.jpeg'
import { showErrorToast, showSuccessToast } from "../../util/util";
import TextEditor from "../section-components/TextEditor";
import { Pageheader } from "./page-header";
import Toast from "../Toast";

const validationSchema = yup.object({
    firstname: yup.string().required("First Name is required"),
    jobtype: yup.string().required("Job Type is required"),
    email: yup
        .string()
        .email("Invalid email format")
        .required("Email is required"),
    number: yup.string().matches(/^(?:\+44|0)7\d{9}$/, "Invalid UK mobile number").required("Contact Number is required"),
    description: yup.string().required("Description is required"),
    // ticketAccount: yup.string().required("Ticket Account is required"),
    // register: yup.boolean().oneOf([true], "You must register"),
    acceptTerms: yup.boolean().oneOf([true], "You must accept terms and conditions"),
});
export const AddJobs = (props) => {
    const navigate = useNavigate();
    const [toastOpen, setToastOpen] = React.useState(false);
    const [toastMessage, setToastMessage] = React.useState("");
    const [typeOptions] = useState([
        { id: 1, label: 'Heating & Plumbing' },
        { id: 2, label: 'Electrical' },
        { id: 2, label: 'Interior Design' },
        { id: 2, label: 'Property Lawyers' },
        { id: 3, label: 'Insurance' },
        { id: 4, label: 'Windows & Doors' },
        { id: 5, label: 'Will Management' },
        { id: 6, label: 'Property Management' },
        { id: 7, label: 'Mortgages' }
    ]);

    const initialValues = {
        firstname: "",
        lastname: "",
        jobtype: "",
        email: "",
        number: "",
        description: "",
        ticketAccount: "",
        register: false,
        acceptTerms: false,
    };
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            console.log("Form values:", values);
            addJob(values)
                .then((res) => {
                    setToastMessage(res.message);
                    setToastOpen(true);
                    // navigate("/post");
                })
                .catch((err) => {
                    setToastMessage("There was an error submitting the form. Please try again.");
                    setToastOpen(true);
                });
        },
    });
    return (
        <>
            {props.isPage && <Pageheader headertitle="Post A Job" bgImage={bgImage} />}
            <Box className='container py-4'>
                <h3>Post A Job</h3>
                <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: props?.isPage ? 6 : 12 }}>
                            <label htmlFor="name" className="form-label">
                                First Name
                            </label>
                            <TextField
                                fullWidth
                                name="firstname"
                                placeholder="First Name"
                                value={formik.values.firstname}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.firstname &&
                                    Boolean(formik.errors.firstname)}
                                helperText={formik.touched.firstname && formik.errors.firstname} />
                        </Grid>

                        <Grid size={{ xs: 12, md: props?.isPage ? 6 : 12 }}>
                            <label htmlFor="lastname" className="form-label">
                                Last Name
                            </label>
                            <TextField
                                fullWidth
                                name="lastname"
                                placeholder="Last Name"
                                value={formik.values.lastname}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.lastname &&
                                    Boolean(formik.errors.lastname)}
                                helperText={formik.touched.lastname && formik.errors.lastname} />
                        </Grid>
                        <Grid size={{ xs: 12, md: props?.isPage ? 6 : 12 }}>
                            <label htmlFor="jobtype" className="form-label">
                                Job Type
                            </label>
                            <Autocomplete
                                freeSolo
                                options={typeOptions}
                                clearOnEscape
                                value={formik.values.jobtype}
                                onInputChange={(event, newInputValue) => {
                                    formik.setFieldValue("jobtype", newInputValue);
                                }}
                                isOptionEqualToValue={(option, value) => value && option.id === value.id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        name="jobtype"
                                        placeholder="Select Job Type"
                                        variant="outlined"
                                        error={
                                            formik.touched.jobtype && Boolean(formik.errors.jobtype)
                                        }
                                        helperText={formik.touched.jobtype && formik.errors.jobtype} />
                                )} />
                        </Grid>
                        <Grid size={{ xs: 12, md: props?.isPage ? 6 : 12 }}>
                            <label htmlFor="email" className="form-label">
                                Email
                            </label>
                            <TextField
                                fullWidth
                                name="email"
                                placeholder="Email"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && formik.errors.email} />
                        </Grid>
                        <Grid size={{ xs: 12, md: props?.isPage ? 6 : 12 }}>
                            <label htmlFor="number" className="form-label">
                                Contact Number
                            </label>
                            <TextField
                                fullWidth
                                name="number"
                                placeholder="Contact Number"
                                value={formik.values.number}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.number && Boolean(formik.errors.number)}
                                helperText={formik.touched.number && formik.errors.number} />
                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>
                            <label htmlFor="description" className="form-label">
                                Description
                            </label>
                            <TextEditor setFieldWithEditor={(newValue) => formik.setFieldValue('description', newValue)} />
                            {formik.touched.description &&
                                Boolean(formik.errors.description) && (
                                    <Typography color="error">
                                        {formik.errors.description}
                                    </Typography>
                                )}
                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>
                            <FormControlLabel
                                control={<Checkbox
                                    name="register"
                                    checked={formik.values.register}
                                    onChange={formik.handleChange}
                                    color="primary" />}
                                label="Create an account to view your saved properties and searches." />
                            {formik.touched.register &&
                                Boolean(formik.errors.register) && (
                                    <Typography color="error">
                                        {formik.errors.register}
                                    </Typography>
                                )}
                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>
                            <FormControlLabel
                                control={<Checkbox
                                    name="acceptTerms"
                                    checked={formik.values.acceptTerms}
                                    onChange={formik.handleChange}
                                    color="primary" />}
                                label="I have read and agree to the Terms and Conditions, Privacy Policy and Cookies Policy." />
                            {formik.touched.acceptTerms &&
                                Boolean(formik.errors.acceptTerms) && (
                                    <Typography color="error">
                                        {formik.errors.acceptTerms}
                                    </Typography>
                                )}
                        </Grid>
                        <Grid
                            size={{ xs: 12, md: props?.isPage ? 12 : 12 }}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{
                                    marginTop: 2,
                                    backgroundColor: '#d8b035',
                                    color: 'white',
                                    '&:hover': {
                                        backgroundColor: '#c5a02f',
                                    },
                                    '@media (max-width: 600px)': {
                                        fontSize: '1rem',
                                    },
                                }}
                            >
                                Submit
                            </Button>
                        </Grid>
                    </Grid>
                </form>
                <Toast
                    open={toastOpen}
                    message={toastMessage}
                    onClose={() => setToastOpen(false)}
                    severity={toastMessage.includes('success') ? "success" : "error"}
                    autoHideDuration={6000}
                />
            </Box></>
    )
}